//
import FamilyModel from "@/models/Warehouse/WhFamily"
import SubfamilyModel from "@/models/Warehouse/WhSubfamily"
import WarehouseModel from "@/models/Warehouse/WhWarehouse"

//
export default [
    {
        name: "search",
        props: {
            label: "Búsqueda",
        },
        type: "text-field",
    },
    {
        name: "alias_search",
        props: {
            label: "Alias",
        },
        type: "text-field",
    },
    {
        name: "name",
        props: {
            label: "Nombre",
        },
        type: "text-field",
    },
    {
        name: "internal_code",
        props: {
            label: "Código Interno",
        },
        type: "text-field",
        value: "",
    },
    {
        name: "upc_code",
        props: {
            label: "Código UPC",
        },
        type: "text-field",
        value: "",
    },
    {
        name: "of_warehouse",
        props: {
            chips: true,
            itemText: "name",
            itemValue: "id",
            label: "Bodega",
            model: WarehouseModel,
            noObject: true,
        },
        type: "autocomplete-model"
    },
    {
        name: "wh_family_id",
        props: {
            chips: true,
            itemText: "family",
            itemValue: "id",
            label: "Familia",
            model: FamilyModel,
            noObject: true,
        },
        type: "autocomplete-model"
    },
    {
        name: "wh_subfamily_id",
        props: {
            chips: true,
            itemText: "subfamily",
            itemValue: "id",
            label: "Sub Familia",
            model: SubfamilyModel,
            noObject: true,
            paramSearch: "subfamily",
        },
        type: "autocomplete-model"
    },
    {
        name: "is_salable",
        props: {
            chips: true,
            items: [
                {
                    text: "No",
                    value: false,
                },
                {
                    text: "Si",
                    value: true,
                },
            ],
            label: "Vendible",
        },
        type: "select",
        value: "",
    },
    {
        name: "is_repackaged",
        props: {
            chips: true,
            items: [
                {
                    text: "No",
                    value: false,
                },
                {
                    text: "Si",
                    value: true,
                },
            ],
            label: "Reenvasable",
        },
        type: "select",
        value: "",
    },
    {
        name: "is_consumable",
        props: {
            chips: true,
            items: [
                {
                    text: "No",
                    value: false,
                },
                {
                    text: "Si",
                    value: true,
                },
            ],
            label: "Consumible",
        },
        type: "select",
        value: "",
    },
]